import React, {useEffect, useMemo, useState} from 'react';
import * as Yup from 'yup';
import {
  Alert,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  FormControlLabel,
  Grid,
  Paper,
  Snackbar,
  Stack,
  Switch,
  TextField,
  Typography
} from '@mui/material';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {useSnackbar} from 'notistack';

import {useForm, FormProvider, Controller} from 'react-hook-form';
// import {useAppContext} from '@context/AppContext';
import {LoadingButton} from '@mui/lab';
import {yupResolver} from '@hookform/resolvers/yup';
import {RHFEditor} from 'src/minimal-components/hook-form';

import {useTranslation} from 'react-i18next';
import blendedlearning from '../blendedlearning.png';
import selflearnin from '../selflearnin.png';
import {
  getLMSResultsData,
  getSearchForm,
  postCourseData
} from '@shared/services/service-handlers/PrivateService';
import EncryptUtils from 'src/utils/EncryptUtils';
import {useAppContext} from '@context/AppContext';
import {useLocation} from 'react-router-dom';
import {BASE_RECORD_ID, LMS_TYPE} from 'src/routes/BaseRoute';
import {LoadingScreen} from 'src/minimal-components/loading-screen';

interface CourseType {
  typecourse: number; // Assuming each type has an ID for key purposes in rendering
  name: string; // Self paced learning or Blended learning
}
interface CourseDetails {
  id: number;
  Title: string;
  RTEContent: string;
  CreatedByName: string;
  course_status: string;
  CourseType: number; // This should match one of the CourseType.CourseType values
}
interface OverviewType {
  courseTypes: CourseType[];
  courseDetails: CourseDetails[];
}
interface OverviewpageProps {
  overviewDatas?: OverviewType;
  uiFields: any;
}

const Overviewpage = ({
  overviewDatas,
  uiFields
}: OverviewpageProps): React.ReactElement => {
  // const {
  //   appState: {applicationName}
  // } = useAppContext();
  const NewJobSchema = Yup.object().shape({
    Title: Yup.string().required('Title is required'),
    content: Yup.string().required('Content is required')
  });
  const [loader, setLoaders] = useState(true);
  const recordId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const lmstype = EncryptUtils.getDecryptedData(location?.search, LMS_TYPE);

  const {
    appState: {applicationName}
  } = useAppContext();
  const {t} = useTranslation();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [overviewData, setOverviewData] = React.useState<CourseDetails | null>(
    overviewDatas?.courseDetails[0] || null
  );

  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [courseType, setCourseType] = React.useState<CourseType[]>(
    overviewDatas?.courseTypes || []
  );
  const [published, setPublished] = React.useState(
    overviewDatas?.courseDetails[0].course_status
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selctedCourseName, setSelctedCourseName] = React.useState(1);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isButtonLoading, setIsButtonLoading] = React.useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [numbers, setNumbers] = React.useState(0);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [uniqueId, setuniqueId] = React.useState(overviewData.id);
  const [selectedCourseType, setSelectedCourseType] = React.useState<number>(
    overviewDatas?.courseDetails[0].CourseType || 1
  );
  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = uiFields;
        if (uiFields === null || uiFields === undefined) {
          response = await getSearchForm('LMS', 'overview');
        }
        const {sql_data} = response.searchForm.update_overviewdata;
        const data: any = {
          sql_data: sql_data,
          data: {
            course_overview_id: recordId,
            id: recordId
          },
          operation: 'SEARCH'
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        setOverviewData(result.data[0]);
        setPublished(result.data[0].course_status);
        setLoaders(false);
      } catch (e) {
        console.log(e);
        setLoaders(false);
      }
    };
    fetchData();
  }, []);
  const defaultValues = useMemo(
    () => ({
      Title: overviewData?.Title || '',
      content: overviewData?.RTEContent || ''
    }),
    [overviewData]
  );
  const methods = useForm({
    resolver: yupResolver(NewJobSchema),
    defaultValues
  });
  const {
    control,
    formState: {errors, isSubmitting},
    reset,
    handleSubmit
  } = methods;
  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);
  const handleCourseTypeChange = (course: any) => {
    setSelectedCourseType(course.typecourse);
    setSelctedCourseName(course.name);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };
  const onSubmit = async (datavalue: any) => {
    try {
      setIsButtonLoading(true);

      let response = uiFields;
      if (uiFields === null || uiFields === undefined) {
        response = await getSearchForm('LMS', 'overview');
      }
      const {sql_data} = response.searchForm.update_overviewdata;
      const data: any = {
        sql_data: sql_data,
        data: {
          name: datavalue.Title,
          overview_rte_content: datavalue.content,
          course_status: published,
          course_type_id: selectedCourseType,
          id: overviewData?.id
        },
        operation: 'UPDATE'
      };
      const encryptRequestData = EncryptUtils.encryptedData(data);
      const result = await getLMSResultsData(applicationName, 'LMS', {
        tk: encryptRequestData
      });
      setOverviewData(result.data[0]);
      setOpenSnackbar(true);
      setIsButtonLoading(false);
    } catch (e) {
      setIsButtonLoading(false);
    }
  };
  const handlepublish = () => {
    if (published === 'PUBLISHED') {
      setPublished('DRAFTED');
    } else {
      setPublished('PUBLISHED');
    }
  };
  const renderActions = (
    <Grid
      sx={{
        display: 'flex',
        margin: '1vh,0',
        flex: '1',
        alignItems: 'flex-end',
        py: '1vh',
        justifyContent: 'flex-end'
      }}>
      <Grid xs={12} md={8}>
        <FormControlLabel
          control={
            <Switch
              checked={published === 'PUBLISHED'}
              value={published}
              disabled={published === 'PUBLISHED'}
              defaultChecked={false}
              onClick={handlepublish}
            />
          }
          label="Publish"
          sx={{flexGrow: 1, pl: 3}}
        />
      </Grid>
      <Grid xs={12} md={4}>
        {/* <LoadingButton
            type="reset"
            variant="outlined"
            // onClick={onReset}
            // loading={isSubmitting}
            // disabled={searchLoader ? true : false}
            sx={{
              mr: 2
            }}>
            {t('PRIVATE.COMMON.CLEAR', {ns: 'private'})}
          </LoadingButton> */}
        <LoadingButton
          type="submit"
          variant="contained"
          loading={isButtonLoading}
          size="small"
          onClick={() => {
            onSubmit;
          }}
          sx={{ml: 2}}>
          {'Save'}
        </LoadingButton>
      </Grid>
    </Grid>
  );
  return loader ? (
    <Stack
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      minHeight={'80vh'}>
      <LoadingScreen />
    </Stack>
  ) : (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Container
            sx={{
              backgroundColor: 'white',
              borderRadius: '8px',
              maxWidth: '100% !important',
              minHeight: '72vh',
              flexDirection: 'column',
              rowGap: 1,
              display: 'flex'
            }}>
            <Grid xs={12} rowSpacing={1}>
              <Stack
                spacing={1.5}
                sx={{paddingTop: '1vh', marginBottom: '1.5vh'}}>
                <Typography variant="subtitle2">Title</Typography>
                <Controller
                  name="Title"
                  control={control}
                  render={({field}) => (
                    <TextField
                      {...field}
                      size="small"
                      contentEditable={lmstype !== 'view' ? true : false}
                      error={!!errors.Title}
                      helperText={errors.Title?.message}
                      sx={{width: '50vw'}}
                    />
                  )}
                />
              </Stack>
            </Grid>

            {/* <Grid xs={12} rowSpacing={1}>
              {lmstype !== 'view' && (
                <Stack
                  spacing={1.5}
                  sx={{paddingTop: '1vh', marginBottom: '1.5vh'}}>
                  <Typography variant="subtitle2">Course Type</Typography>
                  <div style={{display: 'flex', columnGap: '2vh'}}>
                    {courseType.map(coursetype => (
                      <label key={coursetype.typecourse}>
                        <div
                          style={{display: 'flex', justifyContent: 'center'}}>
                          {coursetype.typecourse === 1 ? (
                            <img
                              src={selflearnin}
                              alt={`'${coursetype.name}'`}
                              style={{width: '8vh'}}
                            />
                          ) : (
                            <img
                              src={blendedlearning}
                              alt={`'${coursetype.name}'`}
                              style={{width: '8vh'}}
                            />
                          )}
                        </div>
                        <div>
                          <input
                            type="radio"
                            name="courseType"
                            value={coursetype.typecourse}
                            checked={
                              selectedCourseType === coursetype.typecourse
                            }
                            onChange={() => handleCourseTypeChange(coursetype)}
                          />
                          {coursetype.name}
                        </div>
                      </label>
                    ))}
                  </div>
                </Stack>
              )}
            </Grid> */}

            <Grid display={'flex'} paddingBottom={'2vh'} columnGap={'2vh'}>
              <RHFEditor
                toolbarpresent={lmstype !== 'view'}
                simple
                name="content"
                sx={{width: '-webkit-fill-available'}}
              />

              <Grid xs={12} md={4} display={'grid'}>
                <Card
                  sx={{
                    border: 'solid 1px rgba(145, 158, 171, 0.2)',
                    p: '1vh',
                    minWidth: '30vh'
                  }}>
                  <CardContent>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        paddingBottom: '0.5vh'
                      }}>
                      {published === 'PUBLISHED' ? (
                        <Button
                          variant="contained"
                          size="small"
                          sx={{ml: 2, backgroundColor: 'green'}}>
                          {'Published'}
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          size="small"
                          sx={{ml: 2, backgroundColor: 'blue'}}>
                          {'Drafted'}
                        </Button>
                      )}
                    </div>

                    <Typography variant="subtitle2" paddingBottom={'1vh'}>
                      Created By
                    </Typography>
                    <div style={{display: 'flex'}}>
                      <Avatar>{overviewData?.CreatedByName[0]}</Avatar>
                      <Typography
                        variant="h5"
                        component="div"
                        alignContent={'center'}
                        sx={{pl: '0.5vh'}}>
                        {overviewData?.CreatedByName}
                      </Typography>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            {lmstype !== 'view' && renderActions}
          </Container>
        </form>
      </FormProvider>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{width: '40vw'}}>
          Overview is Saved.
        </Alert>
      </Snackbar>
    </>
  );
};

export default Overviewpage;
